import { useCallback, useState } from 'react';
import { DestinationList } from 'types/stream';

type SelectedDestinationProps = {
  list?: DestinationList;
  defaultState?: string[];
  maxStreamDestinations?: number;
  canUseSamTypeDestination?: boolean;
};

const useSelectedDestinations = ({
  list,
  maxStreamDestinations,
  canUseSamTypeDestination,
  defaultState = list?.filter(d => d.enabled).map(d => d.id) || []
}: SelectedDestinationProps) => {
  const [selectedIds, setSelectedIds] = useState(defaultState);
  const [showLimitMessage, setShowLimitMessage] = useState(false);

  const handleDestinationClick = useCallback(
    (id: string) => {
      if (!selectedIds || !list) return;

      setShowLimitMessage(false);

      const newDestination = list.find(d => d.id === id);
      const activeDestinations = list.filter(d => selectedIds.includes(d.id));

      const hasSameTypeDestination =
        newDestination?.network &&
        activeDestinations.some(d => d.network === newDestination?.network) &&
        !selectedIds.includes(newDestination.id);

      const canShowLimitMessage =
        maxStreamDestinations &&
        !selectedIds.includes(id) &&
        (selectedIds.length >= maxStreamDestinations || (!canUseSamTypeDestination && hasSameTypeDestination));

      if (canShowLimitMessage) {
        setShowLimitMessage(true);
      } else {
        const idsCopy = [...selectedIds];
        idsCopy.includes(id) ? setSelectedIds(idsCopy.filter(ID => ID !== id)) : setSelectedIds([...idsCopy, id]);
      }
    },
    [selectedIds, list?.length]
  );

  return [selectedIds, handleDestinationClick, showLimitMessage, setSelectedIds] as const;
};

export default useSelectedDestinations;
